import { useEffect, useState } from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';

import LdsButton from '../LdsButton/index.jsx';

export default function LdsCookieConsent({
  acceptBtnText = 'I Agree',
  acceptBtnClass = 'outlined',
  acceptBtnAriaLabel,
  cookieStatus,
  declineBtnText = 'I Disagree',
  declineBtnClass = 'outlined',
  declineBtnAriaLabel,
  onAccept,
  onDecline,
  className,
  children,
  ...rest
}) {
  const [isActive, setIsActive] = useState(false);

  useEffect(() => {
    setIsActive(!cookieStatus);
  }, [cookieStatus]);

  return (
    <div
      className={cn(
        'lds-cookie-consent',
        {
          active: isActive,
        },
        className
      )}
      aria-label="Cookie consent"
      {...rest}
    >
      <div className="lds-cookie-consent-content-container wrapper">
        <div className="row align-items-center">
          <div className="col lds-cookie-message-container">
            {children}
          </div>
          <div className="col-12 col-md-auto lds-cookie-consent-btn-container">
            <LdsButton
              className={`lds-button btn-close ${declineBtnClass}`}
              aria-label={declineBtnAriaLabel}
              onClick={onDecline}
            >
              {declineBtnText}
            </LdsButton>
            <LdsButton
              className={`lds-button btn-accept ${acceptBtnClass}`}
              aria-label={acceptBtnAriaLabel}
              onClick={onAccept}
            >
              {acceptBtnText}
            </LdsButton>
          </div>
        </div>
      </div>
    </div>
  );
}

LdsCookieConsent.propTypes = {
  acceptBtnText: PropTypes.string,
  acceptBtnClass: PropTypes.string,
  acceptBtnAriaLabel: PropTypes.string,
  declineBtnText: PropTypes.string,
  declineBtnClass: PropTypes.string,
  declineBtnAriaLabel: PropTypes.string,
  onAccept: PropTypes.func.isRequired,
  onDecline: PropTypes.func.isRequired,
};
